import { createKit } from './instruments';
import type { Style } from './style';

const LOOKAHEAD_S = 0.12;
const TICK_MS = 25;

/** Schedules a style's notes slightly ahead of time, the standard way to get steady Web Audio timing. */
export class Sequencer {
  private timer = 0;
  private step = 0;
  private bar = 0;
  private nextTime = 0;
  energy = 0.4;

  constructor(private readonly ctx: AudioContext, private readonly out: AudioNode, private readonly style: Style) {}

  start(): void {
    this.stop();
    const kit = createKit(this.ctx, this.out);
    this.nextTime = this.ctx.currentTime + 0.05;
    this.timer = window.setInterval(() => {
      const stepLength = 60 / this.style.bpm / 4;
      while (this.nextTime < this.ctx.currentTime + LOOKAHEAD_S) {
        const swing = this.step % 2 === 1 ? this.style.swing * stepLength : 0;
        this.style.play(kit, this.step, this.bar, this.nextTime + swing, stepLength, this.energy);
        this.nextTime += stepLength;
        this.step = (this.step + 1) % 16;
        if (this.step === 0) this.bar += 1;
      }
    }, TICK_MS);
  }

  stop(): void {
    window.clearInterval(this.timer);
  }
}
